/**
 * Vista admin ledger (puntos / donaciones): unificar volumen ARS→USD con tipo de cambio fijo
 * solo para lectura humana (no es tipo de cambio de mercado).
 */
export const LEDGER_ARS_PER_USD_EQUIVALENT = 1420;

export function ledgerUsdEquivalent(usd: number, ars: number): number {
  const u = Number(usd) || 0;
  const a = Number(ars) || 0;
  return u + a / LEDGER_ARS_PER_USD_EQUIVALENT;
}

export function formatLedgerUsdEquivalent(n: number): string {
  return n.toLocaleString("es-AR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}

/** ISO 3166-1 alpha-2 → nombre en español (fallback al código). */
export function regionDisplayNameEs(iso2: string | null | undefined): string | null {
  if (!iso2) return null;
  const c = iso2.trim().toUpperCase();
  if (c.length !== 2) return null;
  try {
    return new Intl.DisplayNames(["es"], { type: "region" }).of(c) ?? c;
  } catch {
    return c;
  }
}

export function ledgerCountryLabel(row: {
  last_sale_country_code?: string | null;
  membership_billing_country?: string | null;
}): { short: string; title?: string } | null {
  const iso = row.last_sale_country_code?.trim();
  if (iso && iso.length === 2) {
    const u = iso.toUpperCase();
    return { short: u, title: regionDisplayNameEs(u) ?? u };
  }
  const bill = row.membership_billing_country?.trim();
  if (bill) return { short: bill.length > 24 ? `${bill.slice(0, 22)}…` : bill };
  return null;
}
